import { sql } from 'drizzle-orm';
import { pgEnum, pgTable, text, timestamp, uuid, uniqueIndex } from 'drizzle-orm/pg-core';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';

export const agentSyncModuleEnum = pgEnum('agent_sync_module', [
  'client_group',
  'account',
  'contact',
  'deal',
  'facility',
  'security',
  'facility_security',
  'facility_fee',
]);

export const agentSyncRefs = pgTable(
  'crm_x_agent_sync_refs',
  {
    id: uuid('id').primaryKey().default(sql`gen_random_uuid()`),
    module: agentSyncModuleEnum('module').notNull(),
    organisationId: uuid('organisation_id').notNull().default(sql`'a0000000-0000-0000-0000-000000000001'::uuid`),
    mailboxId: text('mailbox_id').notNull().default('__default__'),
    externalRef: text('external_ref').notNull(),
    crmxId: uuid('crmx_id').notNull(),
    lastSyncedHash: text('last_synced_hash'),
    lastSyncedAt: timestamp('last_synced_at', { withTimezone: true }).defaultNow().notNull(),
    createdAt: timestamp('created_at', { withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp('updated_at', { withTimezone: true }).defaultNow().notNull(),
  },
  (table) => ({
    scopeModuleExternalRefUnique: uniqueIndex('crm_x_agent_sync_refs_scope_module_external_ref_unique').on(
      table.organisationId,
      table.mailboxId,
      table.module,
      table.externalRef,
    ),
  }),
);

export const insertAgentSyncRefSchema = createInsertSchema(agentSyncRefs);
export const selectAgentSyncRefSchema = createSelectSchema(agentSyncRefs);
